import { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router'
import { Box, Divider, Tab, Tabs } from '@mui/material'
import { useStytchIsAuthorized } from '@stytch/react/b2b'
import { useCurrentAccountContext } from '@/components/accounts/CurrentAccountProvider'
import TabPanel from '@/components/TabPanel'
import CustomVariables from './CustomVariables'
import CustomVariableValues from './CustomVariableValues'
import ValuesAcrossOrgs from './ValuesAcrossOrgs'

const tabsMap: Record<string, number> = {
  variables: 0,
  values: 1,
  values_across_orgs: 2,
}

export default function CustomVariablesDetails() {
  const { '*': id } = useParams()
  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(
    tabsMap[searchParams.get('tab') || ''] ?? 1,
  )
  const { rootOrganization } = useCurrentAccountContext()
  const { isAuthorized: canEdit } = useStytchIsAuthorized('pd.org', 'edit')

  const handleChange = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: number,
  ) => {
    setSelectedTab(newValue)
    setSearchParams(
      (prev) => {
        prev.set('tab', Object.keys(tabsMap)[newValue])
        return prev
      },
      { replace: true },
    )
  }

  useEffect(() => {
    const defaultTab = Object.keys(tabsMap)[1]
    const currentTab = searchParams.get('tab')
    if (!id) {
      navigate(`${rootOrganization.id}?tab=${currentTab ?? defaultTab}`, {
        replace: true,
      })
    } else if (!currentTab) {
      setSearchParams(
        (prev) => {
          prev.append('tab', defaultTab)
          return prev
        },
        { replace: true },
      )
      setSelectedTab(1)
    }
  }, [id, navigate, rootOrganization.id, searchParams, setSearchParams])

  return (
    <Box>
      <Tabs value={selectedTab} onChange={handleChange}>
        {canEdit && <Tab label="Variables" value={tabsMap.variables} />}
        <Tab label="Values" value={tabsMap.values} />
        <Tab label="Values Across Orgs" value={tabsMap.values_across_orgs} />
      </Tabs>
      <Divider />
      {canEdit && (
        <TabPanel value={selectedTab} index={tabsMap.variables}>
          <CustomVariables />
        </TabPanel>
      )}
      <TabPanel value={selectedTab} index={tabsMap.values}>
        <CustomVariableValues />
      </TabPanel>
      <TabPanel value={selectedTab} index={tabsMap.values_across_orgs}>
        <ValuesAcrossOrgs />
      </TabPanel>
    </Box>
  )
}
